import clsx from 'clsx';

import Tile from '@commons/components/Tile/Tile';

import type { TileBlockProps } from '.';

/**
 * Default variant of the Clickable Tile block.
 */

const TileBlockDefault = ({ content }: TileBlockProps) => {
  const { image, title, tag, theme, justify, link, aspectRatio } = content;

  const classes = clsx(!aspectRatio && 'w-100 h-100');

  return (
    <Tile
      tag={tag}
      href={link?.url || '#'}
      title={title}
      theme={theme}
      image={image}
      justify={justify}
      showButton
      aspectRatio={aspectRatio}
      className={classes}
    />
  );
};

export default TileBlockDefault;
